import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Const} from '../const/const';
import {Observable, of} from 'rxjs';
import {ResultModel} from '../models/result.model';
import {JobAd} from '../models/job-ad.model';

@Injectable({
  providedIn: 'root'
})
export class RecruitService {
    constructor (private http: HttpClient) {}

    saveJobAd(jobAd: any): Observable<ResultModel<JobAd>> {
        return this.http.post<ResultModel<JobAd>>(Const.baseAPI + '/save-job-ad', jobAd);
    }

    updateJobAd(jobAd: any): Observable<void> {
        return this.http.post<void>(Const.baseAPI + '/update-job-ad', jobAd);
    }

    isPublish(data: any): Observable<void> {
        return this.http.post<void>(Const.baseAPI + '/is-publish', data);
    }

    updateTextJobAd(data: any): Observable<void> {
        return this.http.post<void>(Const.baseAPI + '/updateTextJobAd', data);
    }

    checkoutJobAd(data: any): Observable<void> {
      return this.http.post<void>(Const.baseAPI + '/checkout-job-ad', data);
    }

    downloadGDPR(): Observable<boolean> {
      window.location.href = Const.baseAPI + '/downloadGDPR';
      return of(true);
    }
}
